export default {"src":"/_next/static/media/Hyperlipidemia.9a242f0e.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};